// Auto-generated by the generator
// Don't manually edit this file

// @flow

import {registerEffect} from './register'
import {enterRegisterEffect} from './enterRegister'

export const gbiProjectEffects = [
  registerEffect,
  enterRegisterEffect,
]
